import Pusher, { Channel } from "pusher-js";
import { useEffect, useState } from "react";

export const usePusherEvent = (
  channelName: string,
  eventName: string,
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  callback: Function,
  enabled = true
) => {
  const [channel, setChannel] = useState<Channel>();

  // @ts-ignore
  const client: Pusher = window.newPusher;

  useEffect(() => {
    if (!channelName || !client || !client.subscribe || !client.unsubscribe || !enabled) {
      return;
    }

    const existingChannel = client.channel(channelName);

    if (existingChannel) {
      setChannel(existingChannel);
      return;
    }

    const _channel = client.subscribe(channelName);

    setChannel(_channel);

    return () => {
      client.unsubscribe(channelName);
    };
  }, [channelName, client, enabled]);

  useEffect(() => {
    if (channel && callback) {
      channel.bind(eventName, callback);

      return () => {
        channel.unbind(eventName, callback);
      };
    }
  }, [channel, eventName, callback]);
};
